import { createRef } from "react";
import {
  Grid,
  Typography,
  Button,
  Tooltip,
  DialogActions,
} from "../../../../components";
import { useDropzone } from "react-dropzone";

const iconeXML = "https://public.siafevolution.com.br/iconXML.svg";

export function ImportarXmlStep({
  arquivoXml,
  initXmlClose,
  handleXmlChange,
  handleImportarXml,
}) {
  const xmlUpload = createRef();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "text/xml",
    onDrop: (acceptedFiles) => {
      handleXmlChange(acceptedFiles);
    },
  });

  return (
    <>
      <Grid
        container
        spacing={2}
        className="d-flex justify-content-center mb-3"
      >
        <Grid item xs={12} className="d-flex justify-content-center">
          <img src={iconeXML} width={"130px"} alt="Ícone XML" />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        className="d-flex justify-content-center my-3"
      >
        {arquivoXml ? (
          <>
            <Grid item xs={12} className="d-flex justify-content-center">
              <Tooltip title={arquivoXml?.name} placement="top">
                <label htmlFor="contained-button-file" {...getRootProps()}>
                  <input
                    {...getInputProps()}
                    type="file"
                    id="contained-button-file"
                    ref={xmlUpload}
                    style={{ display: "none" }}
                    onChange={(event) => handleXmlChange(event)}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ backgroundColor: "#4FBB53" }}
                    size="large"
                    onClick={() => xmlUpload.current.click()}
                  >
                    Arquivo Selecionado
                  </Button>
                </label>
              </Tooltip>
            </Grid>
            <Grid item xs={12} className="d-flex justify-content-center">
              <Typography>{arquivoXml?.name}</Typography>
            </Grid>
          </>
        ) : (
          <Grid item xs={12} className="d-flex justify-content-center">
            <Tooltip
              title="Arraste ou clique para carregar XML"
              placement="right"
            >
              <label htmlFor="contained-button-file" {...getRootProps()}>
                <input
                  {...getInputProps()}
                  type="file"
                  id="contained-button-file"
                  ref={xmlUpload}
                  style={{ display: "none" }}
                  onChange={(event) => handleXmlChange(event)}
                />
                {isDragActive ? (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ backgroundColor: "#1768aa" }}
                      size="large"
                      onClick={() => xmlUpload.current.click()}
                    >
                      Solte o arquivo aqui
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => xmlUpload.current.click()}
                  >
                    Selecionar Arquivo XML
                  </Button>
                )}
              </label>
            </Tooltip>
          </Grid>
        )}
      </Grid>
      <DialogActions className="d-flex align-items-center justify-content-center mb-3">
        <Button variant="contained" color="padrao" onClick={initXmlClose}>
          Fechar
        </Button>
        <Button variant="contained" color="primary" onClick={handleImportarXml}>
          Importar
        </Button>
      </DialogActions>
    </>
  );
}
